/** 委外导出接口（协同端 cooperativesupplier） */
const EXPORT_BASE = '/qingguang/cooperativesupplier/export'

export const OUTSOURCING_EXPORT_URL = {
  /** 产品委外订单 */
  PRODUCT_ORDER: `${EXPORT_BASE}/exportOutsourcingDoc`,
  /** 产品发料 */
  PRODUCT_MATERIALS: `${EXPORT_BASE}/exportOutsourceRequisitionDoc`,
  /** 产品出货 */
  PRODUCT_FINISH: `${EXPORT_BASE}/exportOutsourcingToWarehouseList`,
  /** 协同库存 */
  WAREHOUSE: `${EXPORT_BASE}/exportOutsourcingWarehouse`,
  /** 委外对账单 */
  STATEMENT: `${EXPORT_BASE}/exportPurchaseBill`,
  /** 工序委外订单（强制已审核） */
  PROCESS_ORDER: `${EXPORT_BASE}/exportProcessOutsource`,
  /** 工序发料 */
  PROCESS_MATERIALS: `${EXPORT_BASE}/exportProcessOutsourceRequisition`,
  /** 工序出货（协同发货） */
  PROCESS_COOP_DELIVERY: `${EXPORT_BASE}/exportProcessCoopDelivery`,
}

/** 从勾选行提取去重后的导出 ids */
export function buildExportIdsList(list, idField) {
  return [
    ...new Set(
      (list || [])
        .map((item) => (item && item[idField] != null ? item[idField] : null))
        .filter((id) => id != null && id !== '')
    ),
  ]
}
